/* eslint-disable @typescript-eslint/no-explicit-any */
import { addDays, differenceInDays } from 'date-fns';

export interface DateConfig {
  from: Date;
  to: Date;
  rangeDays?: number;
}

const REQUEST_RANGE_LIMIT_IN_DAYS = 90;

function isAcceptableDistance({
  from,
  to,
  rangeDays = REQUEST_RANGE_LIMIT_IN_DAYS,
}: DateConfig): boolean {
  const difference = Math.abs(differenceInDays(from, to));

  return difference <= rangeDays;
}

export function splitDateRange(
  { from, to, rangeDays = REQUEST_RANGE_LIMIT_IN_DAYS }: DateConfig,
  dates: DateConfig[] = [],
): DateConfig[] {
  if (isAcceptableDistance({ from, to })) return [...dates, { from, to }];

  const toIntermediaryDate = addDays(from, rangeDays);

  const updatedDates = [...dates, { from, to: toIntermediaryDate }];

  const newFrom = addDays(toIntermediaryDate, 1);

  return splitDateRange({ to, from: newFrom }, updatedDates);
}
